import * as React from "react";
import "./add-item-modal-mobile.less";
import { ModalComponent } from "shared/components/modal/modal";
import {
  formatMoney,
  redirectFileLocalUrl,
} from "shared/plugins/string-helper";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  IProductItemSelectedModel,
  ShoppingCartItem,
} from "states/shopping-cart/shopping-cart.models";
import { faShoppingBasket } from "@fortawesome/free-solid-svg-icons";
import { IProductModel, IVariationAttributeModel, SelectGroupTypeEnum } from "states/menu/menu.models";
import { IconMinus, IconPlus } from "themes";
import { calculateTotal } from "states/shopping-cart/shopping-cart.slice";
import { IVariationAttribute } from "./modal-add-cart";
interface IAddItemModelViewProps {
  openModal: boolean;
  currentProductSelected: IProductItemSelectedModel;
  addProduct: ShoppingCartItem;
  variationAttributes: IVariationAttribute[];
  isSelectedVariation: (va: IVariationAttributeModel) => boolean;
  isDisabledVariation: (va: IVariationAttributeModel) => boolean;
  handleSelectVariation: (va: IVariationAttributeModel) => void;
  handleCloseModal: () => void;
  handleDecreaseQuantity: () => void;
  handleIncreaseQuantity: () => void;
  handleSelectSingle: (modifiers: IProductModel[], modi: IProductModel) => void;
  handleSelectMultiple: (modi: IProductModel) => void;
  handleAddProduct: () => void;
}

export function AddItemModalMobile({
  openModal,
  currentProductSelected,
  addProduct,
  variationAttributes,
  isDisabledVariation,
  isSelectedVariation,
  handleSelectVariation,
  handleCloseModal,
  handleDecreaseQuantity,
  handleIncreaseQuantity,
  handleSelectSingle,
  handleSelectMultiple,
  handleAddProduct,
}: IAddItemModelViewProps) {
  return (
    <ModalComponent
      width={`100%`}
      height={`100%`}
      isModal={false}
      className="w-full"
      isCustomizeFooter={true}
      onCloseModal={handleCloseModal}
      isOpenModal={openModal}
      customizeFooterFixed={
        openModal && (
          <div className="total-container z-50 left-0 py-2 px-4  bg-gray-100 fixed bottom-0 w-full modal--footer">
            <div className="btn--container ">
              <button
                onClick={handleAddProduct}
                className="px-6 py-4 rounded-md w-full font-semibold transition-primary uppercase btn--primary"
              >
                <FontAwesomeIcon icon={faShoppingBasket} size="1x" /> add to
                cart {formatMoney(calculateTotal(addProduct), 2, ".", ",", "$")}
              </button>
            </div>
          </div>
        )
      }
      title={`Add New Item`}
    >
      <div className="py-4 modal-mobile">
        <div className="info-product flex mb-5 ">
          <div className="img-container  mr-2 ">
            <img
              className="object-center"
              src={redirectFileLocalUrl(
                currentProductSelected?.product?.images.length > 0 ? currentProductSelected?.product?.images[0] : "/images/food-place-holder.jpg"
              )}
              alt=""
            />
          </div>
          <div className="flex-auto">
            <div className="name text-sm font-bold uppercase">
              {currentProductSelected?.product?.name}
            </div>

            <div className="flex justify-between content-center items-center px-2">
              <div className="text-red text-base font-semibold uppercase">
                {formatMoney(
                  currentProductSelected?.product?.variationProducts?.length > 0 ? currentProductSelected?.product.variationProducts.find(x => x.id === addProduct.productId)?.sellingPrice : currentProductSelected?.product?.sellingPrice,
                  2,
                  ".",
                  ",",
                  "$"
                )}
              </div>
              <div className="quantity-container flex place-content-center justify-between content-center items-center">
                <button
                  onClick={handleDecreaseQuantity}
                  className="btn--primary rounded-full outline-none p-2"
                >
                  <IconMinus className="img-white" width={20} />
                </button>
                <span className="text-lg">{addProduct?.quantity}</span>
                <button
                  onClick={handleIncreaseQuantity}
                  className="btn--primary rounded-full outline-none p-2"
                >
                  <IconPlus className="img-white" width={20} />
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="des">
          {currentProductSelected?.product?.variationProducts?.length > 0 ?
            (<div dangerouslySetInnerHTML={{ __html: currentProductSelected?.product.variationProducts.find(x => x.id === addProduct.productId)?.description ?? "" }}></div>)
            :
            <div dangerouslySetInnerHTML={{ __html: currentProductSelected?.product?.description }}></div>}
        </div>
        {currentProductSelected?.product?.variationProducts?.length > 0 && variationAttributes?.map((vp) =>
        (
          <div
            className={`type mb-5 select-type`}
          >
            <div className="label-type bg-gray-100 rounded-md text-md p-2  block text-primary uppercase">
              {vp.variationName}
            </div>
            <div className="modifier-list mt-3  space-y-4">
              {vp.variationAttributes?.map((va) => (
                <div
                  key={va.variationValueId}
                  className="item flex justify-between content-center items-center"
                >
                  <div
                    onClick={() => {
                      if (isDisabledVariation(va)) {
                        return;
                      }
                      handleSelectVariation(va);
                    }}
                    className="name">
                    <div className="text-sm inline"> {va.variationValueName} </div>
                  </div>
                  <div className="checkbox--container">
                    <input
                      type="radio"
                      name={va.variationName}
                      value={va.variationValueId}
                      checked={isSelectedVariation(va)}
                      disabled={isDisabledVariation(va)}
                    />
                    <span
                      className={`checkmark ${isDisabledVariation(va) ? 'disabled' : ''}`}
                      onClick={() => {
                        if (isDisabledVariation(va)) {
                          return;
                        }
                        handleSelectVariation(va);
                      }}
                    ></span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
        {currentProductSelected?.modifierGroups?.map((modifierGroup) => {
          return (
            <div
              className={`type mb-5 ${modifierGroup.selectType === SelectGroupTypeEnum.Single
                ? `select-type`
                : `select-modifier`
                }`}
            >
              <div className="label-type bg-gray-100 rounded-md text-md p-2  block text-primary uppercase">
                {modifierGroup.name}
              </div>
              <div className="modifier-list mt-3  space-y-4">
                {modifierGroup?.modifiers?.map((modi) => (
                  <div
                    key={modi.id}
                    className="item flex justify-between content-center items-center"
                  >
                    <div
                      onClick={() => {
                        if (modi.notAdded) {
                          return;
                        }
                        if (modifierGroup.selectType === SelectGroupTypeEnum.Single) {
                          handleSelectSingle(modifierGroup.modifiers, modi);
                        } else {
                          handleSelectMultiple(modi);
                        }
                      }}
                      className="name">
                      <div className="text-sm inline">{modi.name} {modi.label && (<span style={{ color: "gray", fontWeight: "normal" }}>({modi.label})</span>)}</div>
                      <div className="text-sm inline ml-1 ">
                        {formatMoney(modi?.sellingPrice, 2, ".", ",", "$")}
                      </div>
                    </div>
                    {!modi.notAdded && (
                      (
                        modifierGroup.selectType === SelectGroupTypeEnum.Single ? (
                          <div className="checkbox--container">
                            <input
                              type="radio"
                              name={modifierGroup.name}
                              value={modi?.sellingPrice}
                              checked={
                                addProduct.modifiers?.filter(
                                  (m) => m.productId === modi.id
                                )?.length > 0
                              }
                            />
                            <span
                              className="checkmark"
                              onClick={() => {
                                handleSelectSingle(modifierGroup.modifiers, modi);
                              }}
                            ></span>
                          </div>
                        ) : (
                          <div className="checkbox--container">
                            <input
                              checked={
                                addProduct?.modifiers?.filter(
                                  (m) => m.productId === modi.id
                                ).length > 0
                              }
                              type="checkbox"
                              name={modifierGroup.name}
                              value={modi.id}
                            />
                            <span
                              className="checkmark"
                              onClick={() => {
                                handleSelectMultiple(modi);
                              }}
                            ></span>
                          </div>
                        )
                      )
                    )}

                  </div>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </ModalComponent>
  );
}
